import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { LEFT_NAVIGATION_WIDTH } from '../shared/constants/app.constants'
import { IAppState, ICommonState } from '../shared/models/store.model'

const initialState: ICommonState = {
  selectedPageKey: 'Home',
  leftNavigationWidth: LEFT_NAVIGATION_WIDTH,
}

const commonReducer = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setSelectedPageKey(state: any, action: PayloadAction<any>) {
      state.selectedPageKey = action.payload
    },
    setLeftNavigationWidth(state: any, action: PayloadAction<any>) {
      state.leftNavigationWidth = action.payload
    },
  },
})

const rootState = (state: IAppState) => state.common

export const getSelectedPageKey = createSelector(rootState, (state: ICommonState) => state.selectedPageKey)
export const getLeftNavigationWidth = createSelector(rootState, (state: ICommonState) => state.leftNavigationWidth)

export const { setSelectedPageKey, setLeftNavigationWidth } = commonReducer.actions
export default commonReducer
